import clsx from 'clsx';
import { type PropsWithChildren } from 'react';

import { container } from './MultiMeterBarChartOverlay.sty.js';
import { useMeterBarLayoutSize } from '../../../shared/context/MeterBarLayoutSize.context.js';
import { elementSize } from '../../../shared/styles/element-size.sty.js';
import { MultiMeterBarChartTooltip } from '../MultiMeterBarChartTooltip.js';

// TODO use shared component for overlays if possible
export const MultiMeterBarChartOverlay = ({ children }: PropsWithChildren) => {
  const { size } = useMeterBarLayoutSize();

  return (
    <div
      className={clsx(container, elementSize({ size }))}
      data-testid="overlay-wrapper"
    >
      {children}
      <MultiMeterBarChartTooltip />
    </div>
  );
};
